import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/HighlightOff';
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { MerchantActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },
    permission: {
        padding: '5px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantStepSeven = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch, register } = useForm();

    const { classes, data } = props;

    /**
     *
     * 戻るボタン押下時の処理
     *
     */
    const onBackClick = () => {
        props.handleBack();
    }

    /**
     * 
     * 登録ボタン押下時の処理
     * （加盟店情報と手数料情報、アカウント情報を登録）
     * 
     */
    const onSubmit = (data, e) => {
        // 加盟店情報と手数料情報、アカウント情報を保存
        merchantActions.save(token, editing)
            .then(data => {
                // 登録メッセージ表示
                notificationActions.showSuccess('登録しました。');
                // 一覧画面に遷移
                props.handleNext();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    // 事業形態
    var businessForm = '';
    switch (editing.business_form) {
        case 1:
            // 法人
            businessForm = <FormattedMessage id={"Merchant.Corporate"} />;
            break;
        case 2:
            // 個人事業主
            businessForm = <FormattedMessage id={"Merchant.IndividualBusiness"} />;
            break;
    }

    // 法人種別コード種別
    var shopCdtype = '';
    switch (editing.shop_cd_type) {
        case 1:
            // OKICA独自
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeOkica"} />;
            break;
        case 2:
            // JPQR
            shopCdtype = <FormattedMessage id={"Merchant.CorporateCodeTypeJPQR"} />;
            break;
    }

    // 精算サイクル
    var paymentCycle = '';
    switch (editing.payment_cycle) {
        case 1:
            // 月1回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle1"} />;
            break;
        case 2:
            // 月2回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle2"} />;
            break;
        case 2:
            // 月4回
            paymentCycle = <FormattedMessage id={"Merchant.PaymentCycle3"} />;
            break;
    }

    // 代表者性別
    var delegateSex = '';
    switch (editing.delegate_sex) {
        case 1:
            // 男性
            delegateSex = <FormattedMessage id={"Merchant.SexMale"} />;
            break;
        case 2:
            // 女性
            delegateSex = <FormattedMessage id={"Merchant.SexFemale"} />;
            break;
    }

    // 口座種別
    var accountKbn = '';
    switch (editing.account_kbn) {
        case 1:
            // 普通
            accountKbn = <FormattedMessage id={"Merchant.AccountTypeSavings"} />;
            break;
        case 2:
            // 当座
            accountKbn = <FormattedMessage id={"Merchant.AccountTypeCurrent"} />;
            break;
    }

    // 決済代行業者
    var paymentAgencyId = '';
    switch (editing.fee_merchant_create_request.credit_card_payment_agency_id) {
        case 100002:
            // 一般店舗
            paymentAgencyId = <FormattedMessage id={"Merchant.GeneralStore"} />;
            break;
        case 100003:
            // タクシー
            paymentAgencyId = <FormattedMessage id={"Merchant.Taxi"} />;
            break;
        case 100004:
            // 大規模小売
            paymentAgencyId = <FormattedMessage id={"Merchant.Retail"} />;
            break;
    }

    // アカウント区分
    var role = '';
    switch (editing.user_account_create_request.role) {
        case 1:
            // システム管理者
            role = <FormattedMessage id={"Account.Role.SystemAdmin"} />;
            break;
        case 2:
            // 沖縄IC
            role = <FormattedMessage id={"Account.Role.Brand"} />;
            break;
        case 3:
            // 代表加盟店
            role = <FormattedMessage id={"Account.Role.Acquirer"} />;
            break;
        case 4:
            // 一般加盟店
            role = <FormattedMessage id={"Account.Role.Merchant"} />;
            break;
        case 5:
            // 店舗
            role = <FormattedMessage id={"Account.Role.Store"} />;
            break;
    }

    // 設立年月日
    var establishmentDt = '';
    if (editing.establishment_dt != null && editing.establishment_dt != undefined) {
        var dt = new Date(editing.establishment_dt);
        establishmentDt = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // 代表者生年月日
    var delegateBirthday = '';
    if (editing.delegate_birthday != null && editing.delegate_birthday != undefined) {
        var dt = new Date(editing.delegate_birthday);
        delegateBirthday = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);
    }

    // 手数料管理情報_期間
    var sdt = new Date(editing.fee_merchant_create_request.start_date);
    var startDate = sdt.getFullYear() + '-' + ("0" + (sdt.getMonth() + 1)).slice(-2) + '-' + ("0" + sdt.getDate()).slice(-2);
    var edt = new Date(editing.fee_merchant_create_request.end_date);
    var endDate = edt.getFullYear() + '-' + ("0" + (edt.getMonth() + 1)).slice(-2) + '-' + ("0" + edt.getDate()).slice(-2);
    var period = `${startDate}～${endDate}`;

    // 資本金
    var capital = '';
    if (editing.capital != null && editing.capital != undefined && editing.capital != '' && !isNaN(editing.capital)) {
        capital = Number(editing.capital).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }
    // 年商
    var annualSale = '';
    if (editing.annual_sale != null && editing.annual_sale != undefined && editing.annual_sale != '' && !isNaN(editing.annual_sale)) {
        annualSale = Number(editing.annual_sale).toLocaleString('ja-JP', { "style": "currency", "currency": "JPY" });
    }

    // 手数料
    var systemFeeOkicaCardPayment = Number(editing.fee_merchant_create_request.system_fee_okica_card_payment).toFixed(1);
    var brandFeeOkicaCardPayment = Number(editing.fee_merchant_create_request.brand_fee_okica_card_payment).toFixed(1);
    var systemFeeQrPayment = Number(editing.fee_merchant_create_request.system_fee_qr_payment).toFixed(1);
    var brandFeeQrPayment = Number(editing.fee_merchant_create_request.brand_fee_qr_payment).toFixed(1);
    var merchantFeeOkicaCardCharge = Number(editing.fee_merchant_create_request.merchant_fee_okica_card_charge).toFixed(1);
    var merchantFeeOkicaCardValueExchange = Number(editing.fee_merchant_create_request.merchant_fee_okica_card_value_exchange).toFixed(1);
    var systemFeeCreditCardPayment = Number(editing.fee_merchant_create_request.system_fee_credit_card_payment).toFixed(1);
    var brandFeeCreditCardPayment = Number(editing.fee_merchant_create_request.brand_fee_credit_card_payment).toFixed(1);
    var systemFeeBankPayment = Number(editing.fee_merchant_create_request.system_fee_bank_payment).toFixed(1);
    var brandFeeBankPayment = Number(editing.fee_merchant_create_request.brand_fee_bank_payment).toFixed(1);

    // 業種カテゴリー
    var categoryName = '';
    // 業種サブカテゴリー
    var subCategoryName = '';
    var matchedCategory = editing.merchantCategoryCodes.filter(category => category.category_code == editing.category_code);
    if (matchedCategory.length > 0) {
        categoryName = matchedCategory[0].category_name;
        var matchedSubCategory = matchedCategory.filter(category => category.subcategory_code == editing.subcategory_code);
        if (matchedSubCategory.length > 0) {
            subCategoryName = matchedSubCategory[0].subcategory_name;
        }
    }

    return (
        <form className={classes.form} noValidate>
            <Grid container className={classes.form} spacing={2} >
                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.ConfirmTitle" />}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.ConfirmDesc"} /></InputLabel>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepOne" />}</Typography>
                    <Divider />
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.FullName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.contact_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.FullNameFurigana"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.contact_f_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.contact_tel}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Mail"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.mail_adress}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Department"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.contact_depart}</InputLabel>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepTwo" />}</Typography>
                    <Divider />
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{businessForm}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.corporat_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNameInFurigana"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.corporat_f_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.corporat_no}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel1"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_cd_1}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel2"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.shop_cd_2}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{shopCdtype}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.NameInEng"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_e_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.PostalCode"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_postal_code}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Place"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_address}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_tel}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.FaxNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.merchant_fax}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Capital"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{capital}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.AnnualSales"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{annualSale}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.EstablishDate"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{establishmentDt}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.NoOfEmployees"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.employees_number}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.NoOfStores"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.temp_number}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.IndustryCategory"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{categoryName}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.IndustrySubCategory"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{subCategoryName}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessDetail"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.business_content}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.PaymentCycle"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{paymentCycle}</InputLabel>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepThree" />}</Typography>
                    <Divider />
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.FullName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.delegate_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.FullNameFurigana"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.delegate_f_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BirthDate"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{delegateBirthday}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.PostalCode"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.delegate_postal_code}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Address"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.delegate_address}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.delegate_tel}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Sex"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{delegateSex}</InputLabel>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepFour" />}</Typography>
                    <Divider />
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BankName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.financialinstitution_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BankCode"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.financialinstitution_cd}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BranchName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.branch_name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BranchNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.branch_no}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountType"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{accountKbn}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountNumber"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.account_no}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountHolder"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.account_holder}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountHolderFurigana"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.account_f_holder}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.ExternalLinkCd"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.external_link_cd}</InputLabel>
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepFive" />}</Typography>
                    <Divider />
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Period"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{period}</InputLabel>
                </Grid>

                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFeeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardPayment"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{systemFeeOkicaCardPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{brandFeeOkicaCardPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.QRBalanceSettlement"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{systemFeeQrPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{brandFeeQrPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={5}>
                    <Divider />
                </Grid>

                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.ChargeCommissionRate"} /></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardCharge"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{merchantFeeOkicaCardCharge}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardValue"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{merchantFeeOkicaCardValueExchange}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={5}>
                    <Divider />
                </Grid>

                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Shop"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{paymentAgencyId}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.CreditFeeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFee"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{systemFeeCreditCardPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{brandFeeCreditCardPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={5}>
                    <Divider />
                </Grid>

                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFee"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{systemFeeBankPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                </Grid>
                <Grid item xs={2}>
                    <InputLabel component="legend">{brandFeeBankPayment}%</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"></InputLabel>
                </Grid>
                <Grid item xs={5}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.StepSix" />}</Typography>
                    <Divider />
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.AccountName"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.user_account_create_request.name}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Password"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.user_account_create_request.password}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.Division"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{role}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Merchant.MailAddress"} /></InputLabel>
                </Grid>
                <Grid item xs={8}>
                    <InputLabel component="legend">{editing.user_account_create_request.username}</InputLabel>
                </Grid>
                <Grid item xs={4}>
                    <InputLabel component="legend"><FormattedMessage id={"Account.Permission"} /></InputLabel>
                </Grid>
                {Object.keys(editing.user_account_create_request.permissions).map((fld) => {
                    var permission = editing.user_account_create_request.permissions[fld];
                    return (
                        <Grid container className={classes.permission} spacing={2}>                       
                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={4}>
                                <InputLabel component="legend">{permission.type.name}</InputLabel>
                            </Grid>
                            <Grid item xs={2}>
                                <InputLabel component="legend">{permission.value.title}</InputLabel>
                            </Grid>
                        </Grid>
                    )
                })}

                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium"
                        startIcon={<ArrowBackIosIcon />}
                        onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                </Grid>
                <Grid item xs={6}>
                    <Button fullWidth variant="contained" size="medium" color="primary"
                        onClick={handleSubmit(onSubmit)}
                        endIcon={<SaveIcon />}><FormattedMessage id="Button.Register" /></Button>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(MerchantStepSeven);
